/**
 * idleLockMode Store
 * 공통 > 락모드 Store
 *
 * @since 2018-08-22
 * @author ms1124.kim
 */

export const state = () => ({
  isLock: false
})

export const mutations = {
  // 잠금 상태 여부를 설정
  setIsLockMode (state, data) {
    state.isLock = data
  }
}

export const actions = {
  async unlock ({state, commit}, unlockParams) {
    let res = { code: 'ok', result: {} }
    try {
      // Unlock REST API 호출
      res = await this.$axios.$post(`/api/au/login/unlock`, unlockParams, {
        loading: true,
        successAlert: false,
        ignoreHaPrefix: true
      })
    } catch (e) {
      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  }
}

export const getters = {
  isLock (state) {
    return state.isLock
  }
}

export const strict = false
